import * as breakpoints from "../styles/breakpoints";
import * as docketPropTypes from "../docketPropTypes";
import ExternalLink from "./ExternalLink";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { StyleSheet, css } from "aphrodite/no-important";

const styles = StyleSheet.create({
	container: {
		padding: 12,
		display: "flex",
		cursor: "pointer",
		opacity: 1.0,
		transition: "opacity 0.3s",
	},
	disabled: {
		opacity: 0.7,
		cursor: "not-allowed",
	},
	hover: {
		[breakpoints.desktopTrue]: {
			":hover": {
				opacity: 0.8,
			},
		},
	},
});

export default class IconButton extends PureComponent {
	static propTypes = {
		aStyles: docketPropTypes.aphroditeStyles,
		children: PropTypes.node.isRequired,
		disabled: PropTypes.bool.isRequired,
		href: PropTypes.string,
		onClick: PropTypes.func,
		style: PropTypes.object,
		visualHover: PropTypes.bool.isRequired,
	};

	static defaultProps = {
		visualHover: false,
		disabled: false,
	};

	render() {
		let aStyles = [
			styles.container,
			this.props.disabled ? styles.disabled : null,
			this.props.visualHover && !this.props.disabled ? styles.hover : null,
		];
		if (Array.isArray(this.props.aStyles)) {
			aStyles = aStyles.concat(this.props.aStyles);
		} else {
			aStyles.push(this.props.aStyles);
		}

		if (this.props.href) {
			return (
				<ExternalLink
					aStyles={aStyles}
					href={this.props.disabled ? null : this.props.href}
					onClick={this.props.disabled ? null : this.props.onClick}
				>
					{this.props.children}
				</ExternalLink>
			);
		}

		return (
			<a
				className={css(aStyles)}
				onClick={this.props.disabled ? null : this.props.onClick}
				style={this.props.style}
			>
				{this.props.children}
			</a>
		);
	}
}
